module.exports = __webpack_public_path__ + "img/pic4.31da8acd.png";